// Use the same inline SVG pattern as the existing injects.
function insuranceOverviewIcon(name) {
  const paths = {
    search: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
    building:
      'M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16M3 21h18M9 7h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1m-5 6v-3h4v3',
    buildings:
      'M3 21h18M5 21V8l6-4v17M11 21V4m0 4h8v13M8 10h.01M8 14h.01M15 12h1m-1 4h1',
    home: 'M3 11l9-7 9 7M5 9.5V20h5v-6h4v6h5V9.5',
    user: 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z',
    warning:
      'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4m0 4h.01',
    ban: 'M12 22a10 10 0 100-20 10 10 0 000 20zM4.93 4.93l14.14 14.14',
    check: 'M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3',
    copy: 'M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z',
    folder:
      'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z',
    badge:
      'M6 6h12a3 3 0 013 3v9a3 3 0 01-3 3H6a3 3 0 01-3-3V9a3 3 0 013-3zM10 6V4.5A1.5 1.5 0 0111.5 3h1A1.5 1.5 0 0114 4.5V6M9 13.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM6.25 17.5a2.75 2.75 0 015.5 0M14 11.5h4M14 15h3',
    prev: 'M15 18l-6-6 6-6',
    next: 'M9 18l6-6-6-6',
    sortNone: 'M8 9l4-4 4 4M16 15l-4 4-4-4',
    sortAsc: 'M6 15l6-6 6 6',
    sortDesc: 'M6 9l6 6 6-6',
  }
  return `<svg aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="${paths[name]}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>`
}

function luxInsuranceUrl(propertyHrId, id = 'create') {
  return `${baseApiUrl}/properties/${encodeURIComponent(propertyHrId)}/insurances/${encodeURIComponent(id)}`
}

function insuranceCoverageLabel(policy, buildings) {
  if (!policy.assignments.length) return 'Nicht zugeordnet'
  // Describe each coverage separately: one policy can have different scopes per risk.
  const groups = new Map()
  for (const row of policy.assignments) {
    const key = `${row.coverageKind}:${row.mode}`
    if (!groups.has(key)) groups.set(key, { ...row, buildings: [] })
    groups.get(key).buildings.push(row.buildingId)
  }
  return [...groups.values()]
    .map((group) => {
      const scope = group.buildings.includes(null)
        ? 'Gesamtes Objekt (einschließlich künftiger Gebäude)'
        : group.buildings
            .map(
              (id) =>
                buildings.find((b) => b.id === id)?.name || `Gebäude ${id}`
            )
            .join(', ')
      return `${LUX_INSURANCE_KIND_LABELS[group.coverageKind] || group.coverageKind}${group.mode === 'included' ? ' (mitversichert)' : ''}: ${scope}`
    })
    .join('; ')
}

function referenceTitles(items) {
  const shown = items
    .slice(0, 3)
    .map((item) => `„${item.title}“`)
    .join(', ')
  return items.length > 3 ? `${shown} und ${items.length - 3} weitere` : shown
}

const insuranceCount = (count, one, many) =>
  `${count} ${count === 1 ? one : many}`

function insuranceEuro(value, fractionDigits) {
  if (value == null || value === '' || !Number.isFinite(Number(value))) {
    return null
  }
  return `${Number(value).toLocaleString('de-DE', { minimumFractionDigits: fractionDigits, maximumFractionDigits: 2 })} €`
}

function insuranceContactName(contact) {
  return (
    contact?.companyName ||
    [contact?.firstName, contact?.lastName].filter(Boolean).join(' ') ||
    ''
  )
}

/** Building ids a policy covers for one kind; `null` (whole property) expands to every known building. */
function insuranceCoveredBuildings(policy, kind, mode, buildings) {
  return new Set(
    policy.assignments
      .filter(
        (row) => row.coverageKind === kind && (!mode || row.mode === mode)
      )
      .flatMap((row) =>
        row.buildingId === null
          ? buildings.map((building) => building.id).concat('all')
          : [row.buildingId]
      )
  )
}

function insuranceOverlaps(a, b) {
  for (const id of a) if (b.has(id) || id === 'all' || b.has('all')) return true
  return false
}

const insuranceRowRank = (policy) =>
  policy.status === 'ended' ? 2 : policy.assignments.length ? 0 : 1

function insuranceTodayIso(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

/** A missing start or end date leaves the term open on that side. */
function insuranceTermsOverlap(a, b) {
  const start = (policy) => policy.termStartDate || '0000-01-01'
  const end = (policy) => policy.termEndDate || '9999-12-31'
  return start(a) <= end(b) && start(b) <= end(a)
}

/** Other current policies insuring the same kind on the same buildings during an overlapping term. */
function insuranceDuplicatePolicies(policy, rows, buildings) {
  if (policy.status === 'ended') return []
  const kinds = [
    ...new Set(policy.assignments.map((row) => row.coverageKind)),
  ].filter((kind) => kind !== 'other')
  return rows.filter(
    (row) =>
      row.id !== policy.id &&
      row.status !== 'ended' &&
      insuranceTermsOverlap(policy, row) &&
      kinds.some((kind) => {
        const own = insuranceCoveredBuildings(policy, kind, null, buildings)
        const theirs = insuranceCoveredBuildings(row, kind, null, buildings)
        return own.size > 0 && theirs.size > 0 && insuranceOverlaps(own, theirs)
      })
  )
}

const insurancePlanned = (policy, today = insuranceTodayIso()) =>
  policy.status !== 'ended' &&
  Boolean(policy.termStartDate) &&
  policy.termStartDate > today

/** Sortable columns of the overview, in table order; `value` feeds the comparison. */
const LUX_INSURANCE_SORT_COLUMNS = [
  {
    key: 'name',
    label: 'Versicherungsname / Sparte & Risiken',
    value: (policy) => {
      const kind =
        [...policy.types].sort(
          (a, b) => Number(b === 'building') - Number(a === 'building')
        )[0] || ''
      return LUX_INSURANCE_KIND_LABELS[kind] || kind || null
    },
  },
  {
    key: 'scope',
    label: 'Geltungsbereich',
    value: (policy, buildings) =>
      policy.assignments.length
        ? insuranceCoverageLabel(policy, buildings)
        : null,
  },
  {
    key: 'insurer',
    label: 'Versicherer & Makler',
    value: (policy) => insuranceContactName(policy.insurer) || null,
  },
  {
    key: 'due',
    label: 'Fälligkeit / Laufzeit',
    value: (policy) =>
      policy.status === 'ended'
        ? policy.termEndDate || null
        : policy.dueDate || policy.termEndDate || null,
  },
  {
    key: 'documents',
    label: 'Dokumente',
    value: (policy) =>
      policy.documentCount == null ? null : Number(policy.documentCount),
  },
]

/** Clicking a header cycles none → ascending → descending → none. */
function nextInsuranceSort(current, key) {
  if (!current || current.key !== key) return { key, dir: 'asc' }
  if (current.dir === 'asc') return { key, dir: 'desc' }
  return null
}

/**
 * Stable sort by one of `LUX_INSURANCE_SORT_COLUMNS`; empty values stay last in
 * both directions. Without a sort the rows keep the given order.
 */
function sortInsuranceRows(rows, sort, buildings) {
  const column =
    sort && LUX_INSURANCE_SORT_COLUMNS.find((item) => item.key === sort.key)
  if (!column) return [...rows]
  const direction = sort.dir === 'desc' ? -1 : 1
  const compare = (a, b) =>
    typeof a === 'number' && typeof b === 'number'
      ? a - b
      : String(a).localeCompare(String(b), 'de', {
          numeric: true,
          sensitivity: 'base',
        })
  return rows
    .map((row, index) => ({ row, index, value: column.value(row, buildings) }))
    .sort((x, y) => {
      const xEmpty = x.value == null || x.value === ''
      const yEmpty = y.value == null || y.value === ''
      if (xEmpty !== yEmpty) return xEmpty ? 1 : -1
      if (xEmpty) return x.index - y.index
      return compare(x.value, y.value) * direction || x.index - y.index
    })
    .map((entry) => entry.row)
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    LUX_INSURANCE_SORT_COLUMNS,
    nextInsuranceSort,
    sortInsuranceRows,
    insuranceOverviewIcon,
    luxInsuranceUrl,
    insuranceCoverageLabel,
    referenceTitles,
    insuranceCount,
    insuranceEuro,
    insuranceContactName,
    insuranceCoveredBuildings,
    insuranceOverlaps,
    insuranceRowRank,
    insuranceTodayIso,
    insuranceTermsOverlap,
    insuranceDuplicatePolicies,
    insurancePlanned,
  }
}
